export default {
  userName: {
    presence: true
  },
  password: {
    presence: true
  }
};
